import { AppViewMode } from 'src/constants/uiConsts';
import { RouteAction } from 'src/routes/types';

import { OnboardingSetupPage } from './page';

const action: RouteAction = (context) => {
  const isInternalUser = context.portalConfig.viewMode === AppViewMode.INTERNAL;
  const appTitle =
    isInternalUser || context.isAssemblyDomain ? 'Assembly' : 'Copilot';

  return {
    chunks: ['onboarding-setup'],
    ...(isInternalUser
      ? {
          title: `${appTitle} Signup | Create your ${appTitle} Workspace for Free`,
          description: `Start your 14-day free trial of ${appTitle}. No credit card required.`,
        }
      : {}),
    component: <OnboardingSetupPage />,
  };
};

export default action;
